import { useState, useEffect, useRef } from 'react'
import { API, Emoji } from '../../../services/api'

/**
 * Fetches workspace emojis and builds a lookup map by name.
 * The result is cached for the lifetime of the component that uses this hook.
 */
export const useEmojis = (workspaceId: string) => {
  const [emojis, setEmojis] = useState<Map<string, Emoji>>(new Map())
  const [loading, setLoading] = useState(true)
  const fetchedRef = useRef<string | null>(null)

  useEffect(() => {
    if (!workspaceId || fetchedRef.current === workspaceId) return
    fetchedRef.current = workspaceId

    let cancelled = false
    ;(async () => {
      setLoading(true)
      const resp = await API.getInstance().getEmojis({ workspaceId })
      if (!cancelled && resp.ok && resp.data) {
        const map = new Map<string, Emoji>()
        for (const emoji of resp.data) {
          map.set(emoji.name, emoji)
        }
        setEmojis(map)
      }
      if (!cancelled) setLoading(false)
    })()
    return () => {
      cancelled = true
    }
  }, [workspaceId])

  return { emojis, loading }
}
